import { PermissionT } from "../types";

export const orgCompPlanAdjustments = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "org_comp_plan_adjustments");
  return !!p;
};

export default orgCompPlanAdjustments;
